import { useEffect, useState } from "react";
import { Instagram, Play, ExternalLink, Heart, ChefHat } from "lucide-react";
import { api, SOCIALS } from "@/lib/api";

const META = {
  instagram: { Icon: Instagram, label: "Instagram", color: "#E4BD44" },
  patreon: { Icon: Heart, label: "Patreon", color: "#E4BD44" },
  gronda: { Icon: ChefHat, label: "Gronda", color: "#1A1A1A" },
  link: { Icon: Play, label: "Video", color: "#1A1A1A" },
};

function ytEmbed(url) {
  const m = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/shorts\/)([\w-]{11})/);
  return m ? `https://www.youtube.com/embed/${m[1]}` : null;
}

export default function VideoWall({ limit }) {
  const [videos, setVideos] = useState([]);
  useEffect(() => {
    api.get("/videos").then((r) => setVideos(limit ? r.data.slice(0, limit) : r.data)).catch(() => {});
  }, [limit]);

  return (
    <div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-[#2A2A2A] border border-[#2A2A2A]" data-testid="video-wall">
        {videos.map((v) => {
          const meta = META[v.platform] || META.link;
          const embed = v.platform === "youtube" ? ytEmbed(v.url) : null;
          const span = v.span === 2 ? "col-span-2" : "col-span-1";
          return (
            <a
              key={v.id}
              href={v.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`${span} bg-[#0A0A0A] p-5 sm:p-6 group flex flex-col justify-between min-h-[160px] hover:bg-[#141414] transition-colors`}
              data-testid={`video-card-${v.id}`}
            >
              {embed ? (
                <iframe title={v.title} src={embed} className="w-full aspect-video mb-3" allowFullScreen />
              ) : (
                <div className="flex items-center justify-between mb-6">
                  <meta.Icon size={22} style={{ color: meta.color }} />
                  <ExternalLink size={14} className="text-[#9a9484] opacity-0 group-hover:opacity-100 transition-opacity" />
                </div>
              )}
              <div>
                <p className="font-display text-base sm:text-lg leading-snug mb-1.5">{v.title}</p>
                <p className="text-xs text-[#9a9484]">{v.handle} · {meta.label}</p>
              </div>
            </a>
          );
        })}
      </div>
      <div className="flex flex-wrap gap-x-5 gap-y-2 mt-5 text-xs text-[#C9C4B8]" data-testid="social-links-row">
        {SOCIALS.map((s) => (
          <a key={`${s.url}-${s.platform}`} href={s.url} target="_blank" rel="noopener noreferrer" className="ws-link hover:text-[#E4BD44]">
            {s.handle} · {s.platform}
          </a>
        ))}
      </div>
    </div>
  );
}
